import { connect as en_connect } from "../en/connect";

/** connect — RU slice. */
export const connect: Record<keyof typeof en_connect, string> = {
  connect_launcher_title: "Коннект",
  connect_launcher_subtitle:
    "Знакомься вживую — покажи свой QR, чтобы его отсканировали, или подтверди скан и сразу подключайся.",
  connect_launcher_open_button: "Открыть Коннект",

  // Shared error / action labels
  connect_error_title: "Не удалось загрузить",
  connect_error_subtitle: "Проверь соединение и попробуй снова",
  connect_action_try_again: "Попробовать снова",
  connect_action_close: "Закрыть",
  connect_action_done: "Готово",
  connect_action_continue: "Продолжить",

  // QR screen (owner home)
  connect_qr_title: "Твой QR-код",
  connect_qr_hint:
    "Попроси отсканировать этот QR-код, чтобы автоматически создать match с тобой",
  connect_qr_error_title: "Не удалось загрузить твой QR",

  // Scan result (scanner B)
  connect_scan_request_sent_heading: "Запрос отправлен",
  connect_scan_request_sent_to: "для {name}",
  connect_scan_pending_status: "Match в ожидании",
  connect_scan_already_connected_heading: "Ты уже на связи с {name}",
  connect_scan_self_heading: "Нельзя создать связь с самим собой",
  connect_scan_invalid_title: "Недействительная ссылка",
  connect_scan_invalid_subtitle: "Этот QR-код больше не действителен",

  // Match / consent gate (owner A)
  connect_match_error_title: "Не удалось загрузить этот запрос",
  connect_match_heading: "Сделать match с {name}?",
  connect_match_button: "Match",
  connect_match_matching: "Создаём match…",
  connect_match_decline: "Не сейчас",
  connect_match_matched_heading: "У тебя match с {name}",
  connect_match_expired_heading: "Срок запроса истёк",

  // Toasts
  connect_toast_matched_with: "Match с {name}",
  connect_toast_matched: "Match!",
  connect_toast_match_failed: "Не удалось создать match",
};
